"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayerApi = exports.GJGeometryTypeEnum = exports.GJFeatureCollectionTypeEnum = exports.GJFeatureTypeEnum = void 0;
const axios_1 = require("axios");
const globalImportUrl = require("url");
const base_1 = require("../base");
var GJFeatureTypeEnum;
(function (GJFeatureTypeEnum) {
    GJFeatureTypeEnum["Feature"] = "Feature";
})(GJFeatureTypeEnum = exports.GJFeatureTypeEnum || (exports.GJFeatureTypeEnum = {}));
var GJFeatureCollectionTypeEnum;
(function (GJFeatureCollectionTypeEnum) {
    GJFeatureCollectionTypeEnum["FeatureCollection"] = "FeatureCollection";
})(GJFeatureCollectionTypeEnum = exports.GJFeatureCollectionTypeEnum || (exports.GJFeatureCollectionTypeEnum = {}));
var GJGeometryTypeEnum;
(function (GJGeometryTypeEnum) {
    GJGeometryTypeEnum["Point"] = "Point";
})(GJGeometryTypeEnum = exports.GJGeometryTypeEnum || (exports.GJGeometryTypeEnum = {}));
function LayerApiAxiosParamCreator(configuration) {
    return {
        getParticipatoryLayer(options = {}) {
            const localVarPath = `/participatory-layer`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
}
function LayerApiFp(configuration) {
    return {
        getParticipatoryLayer(options) {
            const localVarAxiosArgs = LayerApiAxiosParamCreator(configuration).getParticipatoryLayer(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
}
class LayerApi extends base_1.BaseAPI {
    getParticipatoryLayer(options) {
        return LayerApiFp(this.configuration).getParticipatoryLayer(options)(this.axios, this.basePath);
    }
}
exports.LayerApi = LayerApi;
